'use client'
import { Button } from '@/components/ui/button'

export function ScrollToGiftsButton() {
	const scrollToGifts = () => {
		const giftsSection = document.getElementById('gifts-section')
		if (giftsSection) {
			giftsSection.scrollIntoView({ behavior: 'smooth' })
		}
	}

	return (
		<div className="flex justify-center">
			<Button size="md" onClick={scrollToGifts}>
				Comprar Presentes
			</Button>
		</div>
	)
}
